import axios from 'axios';
import accessTokenRequest from '@/utils/custom-axios';
import {getAccessToken} from '@/utils/access-token';

export const OnDemandService = {
  getDoctors: (queryParams) => {
    return axios.get(
      `${process.env.VUE_APP_DOCTORS_API}/api/directory/getdoctors`,
      {
        params: queryParams,
        transformResponse: [
          (data) => {
            try {
              const response = JSON.parse(data);
              const doctors = JSON.parse(response.payload.doctors).hits.hits
                .map((hit) => ({
                  ...hit._source,
                  blockOffs: response.payload.blockOffs[hit._source.doctorid] || [],
                }));
  
              return doctors;
            } catch (error) {
              return [];
            }
          },
        ],
      },
    );
  },
  getBookingDetails: (bookingID) => {
    const url = `${process.env.VUE_APP_API}/ondemand/details/${bookingID}`;
    return accessTokenRequest.get(url);
  },
  cancelODBooking: (bookingID) => {
    const url = `${process.env.VUE_APP_API}/ondemand/bookings/cancel`;
    return axios.post(
      url,
      { id: bookingID },
      {
        headers: {
          Authorization: `Access ${getAccessToken()}`,
        },
      },
    )
  },
  getOnDemandBookings: () => {
    // gets all statuses except for accept
    const url = `${process.env.VUE_APP_API}/ondemand/bookings?status=1&status=2&status=4&status=5&status=6&status=7`;
    return accessTokenRequest.get(url);
  },
};
